module.exports = __webpack_public_path__ + "static/media/archive.21e0ffce.svg";